<div class="page-container">
  <app-loader *ngIf="!learnset"></app-loader>
  <ng-container *ngIf="learnset">
    
    <div class="header">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
      <div class="title-header">
        <h1>{{learnset!.name}}</h1>
        <app-dropdown [alignment]="'right'" [options]="actionsOptions" (optionSelected)="handleAction($event.action)">
          <button dropdownToggle class="actions-button">
            <tabler-icon name="dots"></tabler-icon>
          </button>
        </app-dropdown>
      </div>
    </div>

    <div *ngIf="learnset.smartRepetitionEnabled && learnset.flashcards.length > 0" class="options-grid">
      <app-custom-progress-widget [headerIcon]="'repeat'" [headerText]="'Bereit zur Wiederholung'" [text1]="learnset.openCards?.toString()!" [text2]="'von ' + learnset.flashcards.length" [progressTotal]="learnset.flashcards.length" [progressValue]="learnset.openCards || 0"></app-custom-progress-widget>
      <app-custom-progress-widget [headerIcon]="'trending-up'" [headerText]="'Lernfortschritt'" [text1]="(learnset.masteredCardsCount! / learnset.flashcards.length * 100 | number: '1.0-0') + '%'" [text2]="'gemeistert'" [progressTotal]="learnset.flashcards.length" [progressValue]="learnset.masteredCardsCount || 0" [progressColor]="'success'"></app-custom-progress-widget>
    </div>

    <div *ngIf="learnset.flashcards.length > 0" class="learn-buttons-container">
      <!--<span class="title">Aktionen</span>-->
      <div *ngIf="learnset.smartRepetitionEnabled" class="learn-button" (click)="learn(true)">
        <i-tabler class="icon-left" name="repeat"></i-tabler>
        <span>Smart wiederholen ({{learnset.openCards}})</span>
        <i-tabler class="icon-right" name="arrow-right"></i-tabler>
      </div>
      <div class="learn-button" (click)="learn(false)">
        <i-tabler class="icon-left" name="repeat"></i-tabler>
        <span>Alle wiederholen ({{learnset.flashcards.length}})</span>
        <i-tabler class="icon-right" name="arrow-right"></i-tabler>
      </div>
    </div>

    <div class="flashcards-section">
      <div class="flashcards-header">
        <span *ngIf="learnset.flashcards && learnset.flashcards.length > 0" class="flashcards-count">{{learnset!.flashcards.length}} Lernkarten</span>
        <app-button *ngIf="learnset.flashcards.length > 0" [text]="'Lernkarten hinzufügen'" [leftIcon]="'fa-plus'" [size]="'small'" [style]="'only-text'" (clickEvent)="addFlashcard()"></app-button>
      </div>

      <app-add-item-widget *ngIf="learnset.flashcards.length === 0" [message]="'Dieses Lernset ist aktuell leer. Möchtest du Lernkarten erstellen?'" [buttonText]="'Lernkarten erstellen'" (buttonClicked)="addFlashcard()"></app-add-item-widget>
      <div class="list">
        <app-flashcard-widget *ngFor="let flashcard of learnset!.flashcards" [flashcard]="flashcard" (actionClicked)="currentFlashcard = flashcard; handleFlashcardAction($event)" [hideDueDate]="!learnset.smartRepetitionEnabled" (actionsClicked)="handleFlashcardActionsClicked($event)"></app-flashcard-widget>
      </div>
    </div>
  </ng-container>
  
  <app-add-button [text]="'Lernkarten hinzufügen'" (clickEvent)="addFlashcard()"></app-add-button>

  <!-- Learnset Actions -->
  <app-bottom-dialog [isVisible]="showActions" [title]="'Aktionen'" (actionCancelled)="showActions = false">
    <app-action-buttons [buttonsList]="actionsList" (actionClicked)="handleAction($event)"></app-action-buttons>
  </app-bottom-dialog>

  <!-- Rename Learnset -->
  <app-bottom-dialog [isVisible]="editLearnsetMode" [title]="'Lernset umbenennen'" (actionCancelled)="editLearnsetMode = false">
    <app-edit-learnset [learnset]="learnset" (actionFinished)="editLearnsetMode = false"></app-edit-learnset>
  </app-bottom-dialog>

  <!-- Flashcard Actions -->
  <app-bottom-dialog [isVisible]="showCreateOptions" [title]="'Lernkarten erstellen'" (actionCancelled)="showCreateOptions = false">
    <app-action-buttons [buttonsList]="createFlashcardsOptions" (actionClicked)="handleFlashcardsOptionClick($event)"></app-action-buttons>
  </app-bottom-dialog>

  <!-- Create Flashcards -->
  <app-bottom-dialog [isVisible]="showManualCreate" [title]="'Lernkarte erstellen'" [size]="'large'" [closeOnOutsideClick]="false" (actionCancelled)="handleFlashcardsCreated()">
    <app-create-flashcard *ngIf="showManualCreate" [learnset]="learnset"></app-create-flashcard>
  </app-bottom-dialog>

  <!-- Edit Flashcard -->
  <app-bottom-dialog [isVisible]="showEditFlashcard" [title]="'Lernkarte bearbeiten'" [size]="'large'" [closeOnOutsideClick]="false" (actionCancelled)="showEditFlashcard = false">
    <app-edit-flashcard [flashcard]="currentFlashcard!" (finished)="showEditFlashcard = false"></app-edit-flashcard>
  </app-bottom-dialog>

  <!-- Flashcard Actions -->
  <app-bottom-dialog [isVisible]="showFlashcardActions" [title]="'Aktionen'" (actionCancelled)="showFlashcardActions = false">
    <app-action-buttons [buttonsList]="flashcardActions" (actionClicked)="handleFlashcardAction($event)"></app-action-buttons>
  </app-bottom-dialog>

  <!-- Learn Options -->
  <app-bottom-dialog [isVisible]="showLearnOptions" [title]="'Karten wiederholen'" (actionCancelled)="showLearnOptions = false">
    <app-action-buttons [buttonsList]="learnOptionsList" (actionClicked)="handleLearnOptionClick($event)"></app-action-buttons>
  </app-bottom-dialog>

  <!-- Flashcard Suggestions -->
  <app-bottom-dialog [isVisible]="showSuggestionCards" [title]="suggestionFlashcards.length + ' Vorschläge'" (actionCancelled)="showSuggestionCards = false">
    <app-suggestions [(flashcards)]="suggestionFlashcards" (actionFinished)="handleSuggestionsFinished()"></app-suggestions>
  </app-bottom-dialog>

  <!-- Onboarding Learn Cards Prompt -->
  <app-bottom-dialog [isVisible]="showLearnPromptDialog" [title]="'Der erste Schritt ist gemacht'" (actionCancelled)="showLearnPromptDialog = false; saveLearnPromptShown()">
    <div class="onboarding-learn-prompt">
      Super! Du hast deine ersten Lernkarten erstellt. 🎉 Möchtest du sie jetzt lernen?
      <app-button [text]="'Neue Lernkarten lernen'" (clickEvent)="handleLearnPromptClicked()"></app-button>
    </div>
  </app-bottom-dialog>
</div>